var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.5C10.6025 0.5 0.5 10.6025 0.5 23C0.5 35.3975 10.6025 45.5 23 45.5C35.3975 45.5 45.5 35.3975 45.5 23C45.5 10.6025 35.3975 0.5 23 0.5ZM32.7875 31.0325C32.4725 31.5725 31.91 31.865 31.325 31.865C31.0325 31.865 30.74 31.7975 30.47 31.6175L23.495 27.455C21.7625 26.42 20.48 24.1475 20.48 22.145V12.92C20.48 11.9975 21.245 11.2325 22.1675 11.2325C23.09 11.2325 23.855 11.9975 23.855 12.92V22.145C23.855 22.955 24.53 24.1475 25.2275 24.5525L32.2025 28.715C33.0125 29.1875 33.2825 30.2225 32.7875 31.0325Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a07984c593d59a8012e582c57dad7fb4.svg";
export { ForwardRef as ReactComponent };